var map = {
	"./new-center-en/New.vue": [
		85249,
		5249
	],
	"./new-center-jp/New.vue": [
		34440,
		4440
	],
	"./new-center-kr/New.vue": [
		44197,
		4197
	],
	"./new-center/New.vue": [
		99894,
		9894
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81659;
module.exports = webpackAsyncContext;